module.exports = require('./helpers/bundle-url').getBundleURL('cZoPv') + "logo-dark.eefe0b7f.svg";